/* eslint-disable */
import React, { useState, useEffect } from 'react';
import PropTypes from 'prop-types';
import {
  Dialog,
  DialogContent,
  DialogTitle,
  DialogActions,
  Typography,
  Button,
  Box,
  Alert,
  Chip,
  Stack,
  Select,
  MenuItem,
  FormControl,
  InputLabel,
  CircularProgress,
} from '@mui/material';
import axiosInstance, { fetcher, postFetcher } from 'src/utils/axios';
import PODialog from './PODialog';
import { useInventory } from 'src/context/inventory-create-provider';

const styles = {
  paper: {
    borderRadius: '12px',
    backgroundColor: '#F5F5F5',
    border: '1px solid #E0E0E0',
    boxShadow: '0 8px 32px rgba(0,0,0,0.12)',
  },
  title: {
    backgroundColor: '#FFFFFF',
    borderBottom: '1px solid #E8E8E8',
    px: 3,
    py: 2,
  },
  content: {
    backgroundColor: '#F5F5F5',
    px: 3,
    pt: 2,
  },
  alert: {
    backgroundColor: '#FFF8E1',
    border: '1px solid #FFD54F',
    borderRadius: '8px',
    color: '#7C5A00',
    mb: 2,
    '& .MuiAlert-icon': { color: '#F59E0B' },
  },
  itemCard: {
    p: 2,
    bgcolor: '#FFFFFF',
    borderRadius: '8px',
    border: '1px solid #E0E0E0',
  },
  actions: {
    backgroundColor: '#FFFFFF',
    borderTop: '1px solid #E8E8E8',
    px: 3,
    py: 2,
    gap: 1,
  },
  cancelBtn: {
    color: '#374151',
    borderColor: '#D1D5DB',
    borderRadius: '8px',
    minWidth: 100,
    textTransform: 'none',
    fontWeight: 500,
    '&:hover': {
      borderColor: '#9CA3AF',
      backgroundColor: '#F9FAFB',
    },
  },
  confirmBtn: {
    backgroundColor: '#1A1A2E',
    color: '#FFFFFF',
    borderRadius: '8px',
    minWidth: 140,
    textTransform: 'none',
    fontWeight: 500,
    '&:hover': { backgroundColor: '#2D2D4E' },
    '&:disabled': {
      backgroundColor: '#D1D5DB',
      color: '#9CA3AF',
    },
  },
  proceedBtn: {
    backgroundColor: '#10B981',
    color: '#FFFFFF',
    borderRadius: '8px',
    minWidth: 100,
    textTransform: 'none',
    fontWeight: 500,
    '&:hover': { backgroundColor: '#059669' },
  },
};

export default function QuantityWarningDialog({
  open,
  onClose,
  report = [],
  jobId,
  onConfirm = () => {},
  setWarningData
}) {
    const {updatejobpayload} = useInventory();
  
 const {calculationtype,calculationquantity,isallocablecalculated,jobpayload}=useInventory()
 console.log('isallocablecalculated',isallocablecalculated)
 console.log('calculationtype yoyy',calculationtype,calculationquantity)
  const [openPODialog, setOpenPODialog] = useState(false);
  const [showProceedButton, setShowProceedButton] = useState(false);


  const [itemStates, setItemStates] = useState({});

  const safeReport = Array.isArray(report) ? report : [];
  const hasShortage = safeReport.some((r) => r.shortage_qty > 0);
  const nodeids = safeReport.map((item) => item?.node_id);


  const setItemField = (idx, field, value) => {
    setItemStates((prev) => ({
      ...prev,
      [idx]: {
        ...prev[idx],
        [field]: value,
      },
    }));
  };

  // Format variant attributes for display
  const formatVariantLabel = (variant) => {
    if (!variant.attributes) return `Variant ${variant.id}`;
    const attrs = Object.entries(variant.attributes)
      .map(([key, value]) => `${key}: ${value}`)
      .join(', ');
    return attrs || `Variant ${variant.id}`;
  };


  useEffect(() => {
    if (!open || !hasShortage) return;

    safeReport.forEach((item, idx) => {
      if (!item || item.shortage_qty <= 0) return;

      setItemStates((prev) => ({
        ...prev,
        [idx]: {
          variants: [],
          selectedVariant: '', 
          loadingVariants: true,
          ...(prev[idx] || {}),
        },
      }));

      const productId = item.product?.id;
      if (productId) {
        postFetcher(['products-app/inventory-variant/list/', 
          { product_ids: [productId],required_qty: item.required_qty }])  
      
          .then((res) => {  
            const data = res || [];
            setItemStates((prev) => ({
              ...prev,
              [idx]: {
                ...prev[idx],
                variants: data,
                selectedVariant: '', 
                loadingVariants: false,
              },
            }));
          })
          .catch((e) => {
            console.error(`Failed to load variants for product ${productId}:`, e);
            setItemField(idx, 'loadingVariants', false);
          });
      } else {
        setItemField(idx, 'loadingVariants', false);
      }
    });
  }, [open]);

  // Reset item states when dialog closes
  useEffect(() => {
    if (!open) {
      setItemStates({});
      setShowProceedButton(false);
    }
  }, [open]);


  useEffect(() => {
    const hasAnySelection = safeReport
      .filter((r) => r.shortage_qty > 0)
      .some((_, idx) => !!itemStates[idx]?.selectedVariant);
    
    setShowProceedButton(hasAnySelection);
  }, [itemStates, safeReport]);



const handleProceed = async() => {
  // Collect all selections in the exact format you want
  const payload = safeReport
    .filter((item, idx) => item.shortage_qty > 0 && itemStates[idx]?.selectedVariant)
    .map((item, idx) => {
      const originalIndex = safeReport.findIndex((r) => r.node_id === item.node_id);
      const selectedVariant = itemStates[originalIndex]?.selectedVariant;
      const oldVariantId = item.variant?.id;
      
      return {
        node_id: item.node_id,
        required_qty: item.required_qty,
        shortage_qty: item.shortage_qty,
        old_variant: oldVariantId,
        new_variant: selectedVariant,
       
      };
    });
const formData = new FormData();
 formData.append('data', JSON.stringify(payload)); // Stringify the array
  formData.append('is_allocable', JSON.stringify(isallocablecalculated));
formData.append('job_payload', JSON.stringify(jobpayload));
  const res = await axiosInstance.post(
    `new/workflow-app/input-variant/update/?mode=${calculationtype}&value=${calculationquantity}`, 
    formData  // Now payload is exactly the array format you want
  );
  
  if(res?.data.shortage_detected){
    setWarningData(res?.data?.inventory_availability)
    setOpenPODialog(true)
  }else{
    updatejobpayload([])
  }

  
onClose();
};
  const handleGeneratePO = () => {
    setOpenPODialog(true);
    onClose();
  };

  const handlePOClose = () => {
    setOpenPODialog(false);
    onConfirm?.();
  };

  // Check if any variant has been selected (for enabling proceed button)
  const hasAnySelection = safeReport
    .filter((r) => r.shortage_qty > 0)
    .some((_, idx) => !!itemStates[idx]?.selectedVariant);

  // Build enriched report: attach selectedVariant per item for PODialog
  const enrichedReport = safeReport.map((item, idx) => ({
    ...item,
    selectedVariantId: itemStates[idx]?.selectedVariant || '',
  }));

  return (
    <>
      <Dialog
        open={open}
        onClose={onClose}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: styles.paper }}
      >
        <DialogTitle sx={styles.title}>
          <Typography
            variant="h6"
            fontWeight={600}
            fontSize="1rem"
            color="#1A1A2E"
            letterSpacing="-0.01em"
          >
            Quantity Warning
          </Typography>
        </DialogTitle>

        <DialogContent sx={styles.content}>
          <Alert severity="warning" sx={styles.alert}>
            <Typography variant="body2" fontWeight={500} color="#7C5A00">
              Insufficient Quantity Available
            </Typography>
          </Alert>

          <Stack spacing={1.5} sx={{ mb: 2 }}>
            {safeReport.map((item, idx) => {
              const state = itemStates[idx] || {};
              const { 
                variants = [],
                selectedVariant = '',
                loadingVariants = false
              } = state;

              return (
                <Box key={idx} sx={styles.itemCard}>
                  {/* Product name + node */}
                  <Stack direction="row" justifyContent="space-between" alignItems="flex-start" sx={{ mb: 0.5 }}>
                    <Typography
                      variant="subtitle2"
                      fontWeight={600}
                      color="#1A1A2E"
                      fontSize="0.85rem"
                    >
                      {item.product.name}
                    </Typography>
                    <Chip
                      label={item.node_name}
                      size="small"
                      sx={{
                        backgroundColor: '#EEF2FF',
                        color: '#4338CA',
                        fontSize: '0.68rem',
                        height: '20px',
                        border: '1px solid #C7D2FE',
                      }}
                    />
                  </Stack>

                  {/* SKU */}
                  <Typography variant="caption" color="#9CA3AF" sx={{ mb: 1, display: 'block' }}>
                    SKU: {item.product.sku}
                  </Typography>

                  {/* Current variant attributes chips */}
                  <Stack direction="row" spacing={0.75} flexWrap="wrap" sx={{ mb: 1.5 }}>
                    {Object.entries(item.variant.attributes)
                      .filter(([, v]) => v)
                      .map(([k, v]) => (
                        <Chip key={k} label={`${k}: ${v}`} size="small" color="default" />
                      ))}
                  </Stack>

                  {/* Qty stats */}
                  <Box
                    sx={{
                        display: 'grid',
                      gridTemplateColumns: '1fr 1fr 1fr',
                      gap: 1,
                      pt: 1,
                      mb: 1.5,
                      borderTop: '1px solid #F0F0F0',
                    }}
                  >
                    <Box>
                      <Typography sx={{ fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#9CA3AF', fontWeight: 600, mb: 0.25 }}>
                        Required
                      </Typography>
                      <Typography variant="body2" fontWeight={700} sx={{ color: '#DC2626', fontSize: '0.9rem' }}>
                        {item.required_qty}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography sx={{ fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#9CA3AF', fontWeight: 600, mb: 0.25 }}>
                        Available
                      </Typography>
                      <Typography variant="body2" fontWeight={700} sx={{ color: '#16A34A', fontSize: '0.9rem' }}>
                        {item.available_qty}
                      </Typography>
                    </Box>
                    <Box>
                      <Typography sx={{ fontSize: '0.68rem', textTransform: 'uppercase', letterSpacing: '0.05em', color: '#9CA3AF', fontWeight: 600, mb: 0.25 }}>
                        Short
                      </Typography>
                      <Typography variant="body2" fontWeight={700} sx={{ color: '#D97706', fontSize: '0.9rem' }}>
                        {item.shortage_qty}
                      </Typography>
                    </Box>
                  </Box>

                  {/* Variant dropdown */}
                  <FormControl fullWidth size="small">
                   
                    {loadingVariants ? (
                      <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, py: 1 }}>
                        <CircularProgress size={14} />
                        <Typography variant="caption" color="#9CA3AF">Loading variants…</Typography>
                      </Box>
                    ) : variants.length === 0 ? (
                      <Typography variant="caption" color="#9CA3AF" sx={{ py: 1 }}>
                        No variants available
                      </Typography>
                    ) : (
                      <Select
                        value={selectedVariant}
                        label="Select Variant"
                        onChange={(e) => setItemField(idx, 'selectedVariant', e.target.value)}
                        sx={{ borderRadius: '8px', fontSize: '0.85rem' }}
                        displayEmpty
                      >
                        <MenuItem value="" disabled>
                          <em>Select a variant</em>
                        </MenuItem>
                        {variants.map((v) => (
                          <MenuItem key={v.id} value={v.id}>
                            {formatVariantLabel(v)}
                          </MenuItem>
                        ))}
                      </Select>
                    )}
                  </FormControl>
                </Box>
              );
            })}
          </Stack>

          <Typography variant="body2" fontWeight={500} color="#374151" sx={{ mt: 2 }}>
            Do you want to generate the Purchase Order (PO)?
          </Typography>
        </DialogContent>

        <DialogActions sx={styles.actions}>
          <Button onClick={onClose} variant="outlined" sx={styles.cancelBtn}>
            No
          </Button>
          {/* {showProceedButton && ( */}
            <Button
              onClick={handleProceed}
              variant="contained"
              sx={styles.proceedBtn}
            >
              Proceed
            </Button>
          {/* )} */}

          {/* {!showProceedButton && ( */}
  {/* <Button
            onClick={handleGeneratePO}
            variant="contained"
            disabled={!hasShortage}
            sx={styles.confirmBtn}
          >
            Yes, Generate PO
          </Button> */}
          {/* )

          } */}
        
        </DialogActions>
      </Dialog>

      <PODialog
        open={openPODialog}
        onClose={handlePOClose}
        shortageReport={enrichedReport}
        jobId={jobId}
        nodeids={nodeids}
      />
    </>
  );
}

QuantityWarningDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  report: PropTypes.arrayOf(
    PropTypes.shape({
      product: PropTypes.shape({
        id: PropTypes.number.isRequired,
        name: PropTypes.string.isRequired,
        sku: PropTypes.string,
      }).isRequired,
      variant: PropTypes.shape({
        id: PropTypes.number,
        attributes: PropTypes.object,
      }).isRequired,
      required_qty: PropTypes.number.isRequired,
      available_qty: PropTypes.number.isRequired,
      shortage_qty: PropTypes.number.isRequired,
      node_id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
      node_name: PropTypes.string,
    })
  ),
  jobId: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
  onConfirm: PropTypes.func,
};